<template>
    <div>
        <h3>Optimize Center &nbsp;&nbsp;&nbsp; Total: {{ sum }} 条</h3>
        <el-form class="el_head_search" ref="form" :model="form" label-width="80px">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="用户名" prop="user">
                        <el-input v-model="form.user"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="Prompt" prop="prompt">
                        <el-input v-model="form.prompt"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="12">
                    <el-form-item label="类型" prop="type">
                        <el-select v-model="form.type" placeholder="请选择">
                            <el-option label="全部" value=""></el-option>
                            <el-option label="prompt" value="prompt"></el-option>
                            <el-option label="img-prompt" value="img-prompt"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12" class="btns">
                    <el-button type="primary" size="small" @click="search">搜索</el-button>
                    <el-button type="primary" size="small" @click="resetForm">重置</el-button>
                </el-col>
            </el-row>
        </el-form>

        <el-table v-loading="loading" :data="tableData" border style="width: 100%">
            <el-table-column label="raw-prompt">
                <template slot-scope="scope">
                    {{ scope.row.raw_prompt }}
                </template>
            </el-table-column>
            <el-table-column label="optimize-prompt">
                <template slot-scope="scope">
                    {{ scope.row.new_prompt }}
                </template>
            </el-table-column>
            <el-table-column prop="raw_score" label="raw-score" width="100"></el-table-column>
            <el-table-column prop="new_score" label="optimize_score" width="120"></el-table-column>
            <el-table-column prop="type" label="type" width="140"></el-table-column>
            <el-table-column prop="author_info" label="用户" width="140">
                <template slot-scope="scope">
                    {{ scope.row.author_info.name || scope.row.author_info.displayName || scope.row.author_info.email }}
                </template>
            </el-table-column>
            <el-table-column prop="created_at" label="创建时间(UTC)" width="160">
                <template slot-scope="scope">
                    {{ $moment(new Date(scope.row.created_at).getTime()).utc().format('YYYY-MM-DD HH:mm:ss') }}
                </template>
            </el-table-column>
            <el-table-column prop="raw_imageUrl" label="优化前图片" width="100">
                <template slot-scope="scope">
                    <a v-if="scope.row.raw_imageUrl" class="_link" :href="`https://asset.promptport.ai/files${scope.row.raw_imageUrl}`" target="_blank">{{ $Met.hash(`https://asset.promptport.ai/files${scope.row.raw_imageUrl}`, 6, 10) }}</a>
                    <span v-else-if="scope.row.type === 'img-prompt'">暂未获取</span>
                </template>
            </el-table-column>
            <el-table-column prop="new_imageUrl" label="优化后图片" width="100">
                <template slot-scope="scope">
                    <a v-if="scope.row.new_imageUrl" class="_link" :href="`https://asset.promptport.ai/files${scope.row.new_imageUrl}`" target="_blank">{{ $Met.hash(`https://asset.promptport.ai/files${scope.row.new_imageUrl}`, 6, 10) }}</a>
                    <span v-else-if="scope.row.type === 'img-prompt'">暂未获取</span>
                </template>
            </el-table-column>
            <el-table-column label="详情" fixed="right" width="80" align="center">
                <template slot-scope="scope">
                    <el-button type="text" size="small" slot="reference" :loading="uid === scope.row.uid && detail_loading" @click="handDetail(scope.row)">详情</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="pagination-container">
            <el-pagination background :hide-on-single-page="true" layout="prev, pager, next" :page-size="params.size" :current-page="params.page" :total="total" @current-change="handleCurrentChange"></el-pagination>
        </div>

        <el-dialog title="Optimize Detail" :visible.sync="dialogFormVisible">
            <el-row class="line-bottom">
                <el-col :span="24">
                    <el-row>
                        <el-col :span="4">raw-prompt:</el-col>
                        <el-col :span="20">{{ detail.raw_prompt }}</el-col>
                    </el-row>
                </el-col>
            </el-row>
            <el-row class="line-bottom">
                <el-col :span="24">
                    <el-row>
                        <el-col :span="4">optimize-prompt:</el-col>
                        <el-col :span="20">{{ detail.new_prompt }}</el-col>
                    </el-row>
                </el-col>
            </el-row>
            <el-row class="line-bottom" v-if="detail.type === 'img-prompt'">
                <el-col :span="12">
                    <el-row>
                        <el-col :span="5">优化前图片:</el-col>
                        <el-col :span="19">
                            <a v-if="detail.raw_imageUrl" class="_link" :href="`https://asset.promptport.ai/files${detail.raw_imageUrl}`" target="_blank">{{ $Met.hash(`https://asset.promptport.ai/files${detail.raw_imageUrl}`, 12, 20) }}</a>
                            <span v-else>暂未获取</span>
                        </el-col>
                    </el-row>
                </el-col>
                <el-col :span="12">
                    <el-row>
                        <el-col :span="5">优化后图片:</el-col>
                        <el-col :span="19">
                            <a v-if="detail.new_imageUrl" class="_link" :href="`https://asset.promptport.ai/files${detail.new_imageUrl}`" target="_blank">{{ $Met.hash(`https://asset.promptport.ai/files${detail.new_imageUrl}`, 12, 20) }}</a>
                            <span v-else>暂未获取</span>
                        </el-col>
                    </el-row>
                </el-col>
            </el-row>
            <el-row class="line-bottom">
                <el-col :span="12">
                    <el-row>
                        <el-col :span="5">raw_score:</el-col>
                        <el-col :span="19">{{ detail.raw_score }}</el-col>
                    </el-row>
                </el-col>
                <el-col :span="12">
                    <el-row>
                        <el-col :span="5">new_score:</el-col>
                        <el-col :span="19">{{ detail.new_score }}</el-col>
                    </el-row>
                </el-col>
            </el-row>
            <el-row class="line-bottom">
                <el-col :span="12">
                    <el-row>
                        <el-col :span="5">用户:</el-col>
                        <el-col :span="19">{{ detail.author_info.name || '--' }}</el-col>
                    </el-row>
                </el-col>
                <el-col :span="12">
                    <el-row>
                        <el-col :span="5">创建时间:</el-col>
                        <el-col :span="19">{{ $moment(new Date(detail.created_at).getTime()).utc().format('YYYY-MM-DD HH:mm:ss') }}</el-col>
                    </el-row>
                </el-col>
            </el-row>
        </el-dialog>
    </div>
</template>

<script>
import serverApi from '../../server/index';

export default {
    data() {
        return {
            sum: 0,
            form: {
                user: '',
                prompt: '',
                type: '',
            },

            tableData: [],
            params: {
                page: 1,
                size: 10,
            },
            total: 0,
            loading: true,

            // dialog
            dialogFormVisible: false,
            detail_loading: false,
            uid: '',
            detail: {
                author_info: {},
            },
        };
    },
    created() {
        this.getOptimizeList();
    },
    methods: {
        async getOptimizeList(_params) {
            try {
                const params = {
                    ...this.params,
                    ..._params,
                };
                this.loading = true;
                const { data } = await serverApi.optimizeList(params);
                if (data.code !== 0) throw new Error(data.error);
                this.tableData = data.data;
                this.total = data.total;
                this.params = params;
                if (!this.sum) this.sum = data.total;
            } catch (e) {
                this.$message({
                    message: e.message,
                    type: 'error',
                });
            } finally {
                this.loading = false;
            }
        },
        handDetail(data) {
            this.detail = data;
            this.dialogFormVisible = true;
        },
        handleCurrentChange(val) {
            this.getOptimizeList({ page: val });
        },
        search() {
            this.params = { page: 1, size: 10 };
            this.getOptimizeList(this.form);
        },
        resetForm() {
            this.$refs.form.resetFields();
            this.params = { page: 1, size: 10 };
            this.getOptimizeList(this.form);
        },
        async confirm(item) {
            try {
                const params = {
                    uid: item.uid,
                    open_create: !item.open_create,
                };
                const { data } = await serverApi.opencreate(params);
                if (data.code !== 0) throw new Error(data.error);
                this.getOptimizeList();
                this.$message({
                    message: 'Edit success',
                    type: 'success',
                });
            } catch (e) {
                this.$message({
                    message: e.message,
                    type: 'error',
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
h3 {
    margin-bottom: 30px;
}
.pagination-container {
    display: flex;
    justify-content: center;
    margin-top: 20px;
}
</style>
